import { triggerProgrammaticDownload } from './triggerProgrammaticDownload';

/**
 * Downloads a URL with a forced filename. Uses a Blob URL, since `Content-Disposition` would override `<a download>`.
 */
export async function downloadWithForcedFilename(url: string, filename: string): Promise<void> {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Download failed with status ${res.status}`);
  }

  const blob = await res.blob();
  const blobUrl = URL.createObjectURL(blob);
  try {
    triggerProgrammaticDownload(blobUrl, filename);
  } finally {
    URL.revokeObjectURL(blobUrl);
  }
}
